import './index.css';
import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import { createRoot } from 'react-dom/client';

import App from './App';

GoogleTagManager.initialize({
    customerJourney: 'Account pages',
    trackWithDataAttribute: true
});

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element #root not found');
}
createRoot(container).render(<App />);
